
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../../../framework/state';
import { getResource, putResource } from '../../../../../framework/client/resource';
import TextField from '../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../framework/fields/SelectField.vue';
import { getEnumerationOptions } from '../../../../../framework/service/options';
import SwitchField from '../../../../../framework/fields/SwitchField.vue';
import DateField from '../../../../../framework/fields/DateField.vue';
import NumberField from '../../../../../framework/fields/NumberField.vue';

import { SalesInvoice } from '../../../../../../common/application/model/SalesInvoice';
import { getCustomerOptions } from '../../../../service/application_options_service';
import { SalesInvoiceState } from '../../../../../../common/application/model/enums/SalesInvoiceState';
import { PaymentTerms } from '../../../../../../common/application/model/enums/PaymentTerms';
import SalesInvoiceRows from './row/SalesInvoiceRows.vue';
import { SalesInvoiceType } from '../../../../../../common/application/model/enums/SalesInvoiceType';
import { successToast, errorToast } from '../../../../service/toast_service';
import { updateCachedResourceRow } from '../../../../service/query_cache_service';
import CountrySelectField from '../../../../fields/CountrySelectField.vue';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';

@Component({
    components: {
        DateField,
        NumberField,
        SwitchField,
        SelectField,
        TextField,
        CountrySelectField,
        SalesInvoiceRows,
        ValidationObserver,
    },
})
export default class EditSalesInvoice extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.SALES_INVOICE;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as SalesInvoice,
        salesInvoiceTypeOptions: [] as { id: string | undefined; label: string }[],
        salesInvoiceStateOptions: [] as { id: string | undefined; label: string }[],
        customerOptions: [] as { id: string | undefined; label: string }[],
        paymentTermsOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.customerOptions = await getCustomerOptions();
        this.local.salesInvoiceTypeOptions = getEnumerationOptions(
            'SalesInvoiceType',
            Object.keys(SalesInvoiceType),
            this,
        );
        this.local.salesInvoiceStateOptions = getEnumerationOptions(
            'SalesInvoiceState',
            Object.keys(SalesInvoiceState),
            this,
        );
        this.local.paymentTermsOptions = getEnumerationOptions('PaymentTerms', Object.keys(PaymentTerms), this);
        this.local.row = (await getResource<SalesInvoice>(this.resourceType, this.id))!!;
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    private async saveResource(goBack: boolean) {
        try {
            const updatedRow = await putResource<SalesInvoice>(this.resourceType, this.id, this.local.row);

            successToast(this, 'message.salesInvoiceSaved');
            updateCachedResourceRow<SalesInvoice>(updatedRow, this.id, this.resourceType);

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
